import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cableado',
  templateUrl: './cableado.component.html',
  styleUrls: ['./cableado.component.css']
})
export class CableadoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
